import { State } from "@/store/modules/floatMenu/index";

const setShowFloatMenu = (state: State, payload: boolean) => {
  state.showFloatMenu = payload;
};

const setManageSpace = (state: State, payload: boolean) => {
  state.manageSpace = payload;
};

const setOpenProfile = (state: State, payload: boolean) => {
  state.openProfile = payload;
};

const setOpenProfileSocial = (state: State, payload: boolean) => {
  state.openProfileSocial = payload;
};

const setOpenEmojiSelector = (state: State, payload: boolean) => {
  state.openEmojiSelector = payload;
};

const setOpenConsoleMessage = (state: State, payload: boolean) => {
  state.openConsoleMessage = payload;
};

const setOpenConsoleMessageMultiSpace = (state: State, payload: boolean) => {
  state.openConsoleMessageMultiSpace = payload;
};

const setOpenHelpBotAction = (state: State, payload: boolean) => {
  state.openHelpBot = payload;
};

const setOpenReasonSelector = (state: State, payload: boolean) => {
  state.openReasonSelector = payload;
};

const setShowNextMaintenance = (state: State, payload) => {
  state.showNextMaintennace = payload;
};

const setTimeNextMaintenance = (state: State, payload) => {
  state.timeNextMaintennace = payload;
};

const setOpenCalendarModal = (state: State, payload) => {
  state.openCalendarModal = payload;
};

const setOpenChangeSpaceSelector = (state: State, payload: boolean) => {
  state.openChageSpaceSelector = payload;
};
export default {
  setManageSpace,
  setShowFloatMenu,
  setOpenProfile,
  setOpenEmojiSelector,
  setOpenConsoleMessage,
  setOpenHelpBotAction,
  setOpenReasonSelector,
  setShowNextMaintenance,
  setTimeNextMaintenance,
  setOpenConsoleMessageMultiSpace,
  setOpenCalendarModal,
  setOpenChangeSpaceSelector,
  setOpenProfileSocial,
};
